export const SLICE_NAME = 'clientSurveyResponsePage';
